import React from 'react';
import Slider from 'react-slick';

export default function SqzBenefits() {
  const slideSettings = {
    className: 'slider variable-width',
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    variableWidth: true,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 1,
          variableWidth: false,
          adaptiveHeight: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          variableWidth: false,
          adaptiveHeight: true,
        },
      },
    ],
  };

  return (
    <div>
      <div className="hdg-wave">
        <i className="icon icon--squiggle hdg-wave__icon" />
        <span className="hdg-wave__text">benefits of massage</span>
      </div>
      <div className="select-service__include mb20 mb40-mb">
        <Slider {...slideSettings}>
          <div
            className="select-service__col benefitsSliderCard"
            style={{ width: 320 }}
          >
            <div className="moreInfoColNum">1</div>
            <p className="moreInfoDetailsHead">RELAXATION</p>
            <p className="moreInfoDetailsInfo">
              With our busy lives it’s tough to truly relax. Here’s your chance!
              Put away your phone, close your eyes, and let someone else do the
              work.
            </p>
          </div>
          <div
            className="select-service__col benefitsSliderCard"
            style={{ width: 320 }}
          >
            <div className="moreInfoColNum">2</div>
            <p className="moreInfoDetailsHead">STRESS RELIEF</p>
            <p className="moreInfoDetailsInfo">
              Massage can lower your levels of the stress hormone Cortisol and
              increase your levels of Serotonin and Dopamine. No pill needed.
            </p>
          </div>
          <div
            className="select-service__col benefitsSliderCard"
            style={{ width: 320 }}
          >
            <div className="moreInfoColNum">3</div>
            <p className="moreInfoDetailsHead">PAIN REDUCTION</p>
            <p className="moreInfoDetailsInfo">
              It’s not just pampering. Studies show that massage can reduce pain
              levels, and also improve sleep which helps the healing process.
            </p>
          </div>

          <div
            className="select-service__col benefitsSliderCard"
            style={{ width: 320 }}
          >
            <div className="moreInfoColNum">4</div>
            <p className="moreInfoDetailsHead">HEALTH & WELLNESS</p>
            <p className="moreInfoDetailsInfo">
              Just like exercise and diet, massage can be an important part of
              your self-care regimen. And the best part is, it doesn’t take any
              work!
            </p>
          </div>
          <div
            className="select-service__col benefitsSliderCard"
            style={{ width: 320 }}
          >
            <div className="moreInfoColNum">5</div>
            <p className="moreInfoDetailsHead">SPORTS RECOVERY</p>
            <p className="moreInfoDetailsInfo">
              Decrease recovery time between workouts and help your body get rid
              of built-up lactic acid, so you can be better, faster, and
              stronger.
            </p>
          </div>
          <div
            className="select-service__col benefitsSliderCard"
            style={{ width: 320 }}
          >
            <div className="moreInfoColNum">6</div>
            <p className="moreInfoDetailsHead">PREGNANCY</p>
            <p className="moreInfoDetailsInfo">
              Get relief from those backaches, headaches, leg cramps and
              edema/swelling. Prenatal massage is gentle and nurturing.
            </p>
          </div>
          <div
            className="select-service_row moreInfo3ColDetails"
            style={{ width: 960 }}
          >
            <div className="select-service__col benefitsSliderCardLast">
              <div className="moreInfoColNum">7</div>
              <p className="moreInfoDetailsHead">EMOTIONAL BENEFITS</p>
              <p className="moreInfoDetailsInfo">
                We usually think of touch as purely physical, but it goes so
                much deeper than that. In addition to elevating mood and
                reducing stress,{' '}
                <a
                  aria-label="npr-org-story"
                  href="https://www.npr.org/templates/story/story.php?storyId=128795325"
                >
                  studies show
                </a>{' '}
                that a friendly touch releases oxytocin—the &quot;cuddle
                hormone&quot;—which promotes feelings of trust, empathy, and
                love and is thought to lower anxiety, curb food cravings, and
                improve sleep. Pretty ahhhhmazing, right?
              </p>
            </div>
          </div>
        </Slider>
      </div>
    </div>
  );
}
